<!-- nav -->
<nav class="navbar navbar-expand navbar-dark bg-primary" style="height: 45px;">
  <a class="navbar-brand" href="#">GateCube</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarText" *ngIf="(user && user.token!=null); else elseBlock">
    <ul class="navbar-nav flex-grow-1">
      <li class="nav-item">
        <a class="nav-item nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="user.role==role.Admin">Dashboard</a>
      </li>
      <li class="nav-item">
        <a class="nav-item nav-link" routerLink="/connection/automation/{{user.uId}}" routerLinkActive="active">Automations</a>
      </li>
      <li class="nav-item">
        <a class="nav-item nav-link" routerLink="/user" routerLinkActive="active" *ngIf="user.role==role.Admin">Users</a>
      </li>
      <li class="nav-item dropdown ml-auto">
        <a class="nav-link dropdown-toggle active hidearrow" style="background-image:none" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
          
          <i class="fa fa-shield" aria-hidden="true" *ngIf="user.role==role.Admin"></i>
          <i class="fa fa-user-circle-o" aria-hidden="true" *ngIf="user.role==role.Client"></i>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li><a class="dropdown-item" href="javascript:void(0)" (click)="openChangePasswordDialog()">Change Password</a></li>
          <li><a class="dropdown-item" href="javascript:void(0)" (click)="logout()">Logout</a></li>
         
        </ul>
      </li>
    </ul>
    <!--<span class="navbar-text">
    <a class="nav-item nav-link" (click)="logout()">
      <i class="fa fa-shield" aria-hidden="true" *ngIf="user.role==role.Admin"></i>
      <i class="fa fa-user-circle-o" aria-hidden="true" *ngIf="user.role==role.Client"></i>
      Logout
    </a>
  </span>-->
  
  </div>
  <ng-template #elseBlock>
  </ng-template>
</nav>



<!-- main app container -->
<div class="app-container pt-2">
  <alert></alert>
  <router-outlet></router-outlet>
  <ngx-spinner></ngx-spinner>
</div>
